export default "__VITE_ASSET__DgvJhfHk__"